<div class="wrapper">
  <div class="header">
    <div class="header-overlay">
      <div class="logo-wrapper">
        <ix-icon
          name="ix:logo_truenas_scale_full"
          class="logo"
        ></ix-icon>
      </div>
    </div>
  </div>

  <div mat-dialog-content>
    <div class="help">{{ helptext.help | translate }}</div>
    <div class="line-item">
      <div fxFlex="10%">
        <ix-icon name="assignment" class="bullet-icon"></ix-icon>
      </div>
      <div
        fxFlex="90%"
        class="medium-font"
        [innerHtml]="helptext.docs | translate"
      ></div>
    </div>

    <div class="line-item">
      <div fxFlex="10%"><ix-icon name="group" class="bullet-icon"></ix-icon></div>
      <div
        fxFlex="90%"
        class="medium-font"
        [innerHtml]="helptext.forums | translate"
      ></div>
    </div>

    <div
      *appLet="systemType | mapValue: productTypeLabels as product"
      id="open-source"
      [innerHtml]="helptext.opensource | translate: { product }"
    ></div>
  </div>
</div>

<div mat-dialog-actions id="actions">
  <ix-copyright-line class="copyright-txt"></ix-copyright-line>
  <div id="button-wrapper">
    <button
      mat-button
      class="mat-mdc-button mat-button mat-primary"
      ixTest="close"
      (click)="dialogRef.close(false)"
    >
      {{ helptext.actionBtnText.about | translate | uppercase }}
    </button>
  </div>
</div>
